import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';
import dateUtils from '../utils/DateUtils';

// Serviço da "Análise de perdas" (ex-Coach): diagnóstico read-only de onde o bot perde de forma recorrente.
const LOSS_ANALYSIS_URL = getBaseUrl('/loss-analysis/');

// "Análise de perdas" — leak-detector: símbolos que sangram recorrentemente na janela. Read-only.
export async function getLeaks(startDate, endDate, environment, market, minTrades) {
    startDate = startDate ? startDate.getTime() : dateUtils.getThirtyDaysAgo();
    endDate = endDate ? endDate.getTime() : dateUtils.getTodayEnd();

    const params = { startDate, endDate };
    if (environment) params.environment = environment;
    if (market) params.market = market; // 'futures' | 'spot' — espelha a lente de mercado da tela
    if (minTrades) params.minTrades = minTrades;
    return await appRequest.doGetRequest(`${LOSS_ANALYSIS_URL}leaks?${new URLSearchParams(params).toString()}`);
}

// Plano de ação da Análise de perdas (read-only): automatiza as orientações manuais por símbolo vazando
// (confirmar/diagnosticar/agir/re-medir). Mesmos params de getLeaks.
export async function getActionPlan(startDate, endDate, environment, market, minTrades) {
    startDate = startDate ? startDate.getTime() : dateUtils.getThirtyDaysAgo();
    endDate = endDate ? endDate.getTime() : dateUtils.getTodayEnd();

    const params = { startDate, endDate };
    if (environment) params.environment = environment;
    if (market) params.market = market;
    if (minTrades) params.minTrades = minTrades;
    return await appRequest.doGetRequest(`${LOSS_ANALYSIS_URL}action-plan?${new URLSearchParams(params).toString()}`);
}
